// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_1fCE_","smallLinkTypography":"_1kyt5","titleTypography":"_2Bbvj","cardTitleTypography":"_2fUP8","truncate":"_2zbHr","cardHeader":"_2SAAS","title":"_3SWdO","icons":"_3szvd","narrowPadding":"_1Omrv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CardHeader/CardHeader.scss
// module id = 2479
// module chunks = 0